import api from './api';

export const getConcepts = async () => {
    try {
        const response = await api.get('/api/concepts/getConcepts');
        return response.data;
    } catch (error) {
        return {};
    }
};

export const getConceptsById = async (id) => {
    try {
        const response = await api.get(`/api/concepts/getConceptsById/${id}`);
        return response.data;
    } catch (error) {
        return { result: false, requests: [] };
    }
};

export const createConcepts = async (obj) => {
    try {
        const response = await api.post('/api/concepts/createConcepts', obj);
        return response.data;
    } catch (error) {
        return { result: false };
    }
};

export const updateConcepts = async (id, payload) => {
    const response = await api.put(`/api/concepts/updateConcepts/${id}`, payload);
    return response.data;
};

export const activateConcept = async (id, isActive) => {
    const response = await api.patch(`/api/concepts/activateConcept/${id}/active`, { isActive });
    return response.data;
};

// SUBCONCEPTS
export const getSubConcepts = async () => {
    try {
        const response = await api.get('/api/concepts/getSubConcepts');
        return response.data;
    } catch (error) {
        return {};
    }
};

export const getSubConceptsById = async (id) => {
    try {
        const response = await api.get(`/api/concepts/getSubConceptsById/${id}`);
        return response.data;
    } catch (error) {
        return { result: false, requests: [] };
    }
};

export const createSubConcepts = async (obj) => {
    try {
        const response = await api.post('/api/concepts/createSubConcepts', obj);
        return response.data;
    } catch (error) {
        return { result: false };
    }
};

export const updateSubConcepts = async (id, payload) => {
    const response = await api.put(`/api/concepts/updateSubConcepts/${id}`, payload);
    return response.data;
};

export const activateSubConcept = async (id, isActive) => {
    const response = await api.patch(`/api/concepts/activateSubConcept/${id}/active`, { isActive });
    return response.data;
};

export const getSubConceptsByConcept = async (conceptId) => {
    try {
        const response = await api.get(`/api/concepts/getSubConceptsByConcept/${conceptId}`);
        return response.data;
    } catch (error) {
        return [];
    }
};

export const updateItemMeta = async (obj) => {
    try {
        const response = await api.put('/api/concepts/updateItemMeta', obj);
        return response.data;
    } catch (error) {
        return { result: false };
    }
};